import ErrorLayout from './ErrorLayout';
import SystemErrorDescription from './components/SystemErrorDescription';
import ErrorSideBarContent from './components/ErrorSideBarContent';

export {
  SystemErrorDescription,
  ErrorSideBarContent,
};
export default ErrorLayout;
